import BaseService from "@/app/core/base/BaseService";
import { toast } from "react-toastify";
import { HandleErrors } from "../../util/helpers/ErrorHelper";

export const AddressBookController = {
    BaseModel: {
        name: "",
        street: "",
        neighborhood: "",
        city: "",
        state: "",
        country: "",
        zipCode: "",
        number: "",
        complement: "",
        document: "",
        email: "",
        phone: "",
        phoneExtension: "",
        personType: 0,
        lat: 0,
        lng: 0
    },

    Insert: async function (data, response, error) {
        await BaseService(
            {
                method: "POST",
                url: "addressbook/",
                data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Update: async function (data, response, error) {
        await BaseService(
            {
                method: "PUT",
                url: `addressbook/`,
                data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Delete: async function (id, response, error) {
        await BaseService(
            {
                method: "DELETE",
                url: `addressbook/${id}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Get: async function (response, error) {
        await BaseService(
            {
                method: "GET",
                url: `AddressBook`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },
}